module.exports = __webpack_public_path__ + "static/media/earlexFlyer2Back.0888ea6d.jpg";